const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
    this.parentElement.addEventListener(
      'shopify:section:select',
      () => this.open()
    );
    this.parentElement.addEventListener(
      'shopify:section:deselect',
      () => this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    cartLink?.setAttribute('role', 'button');
    cartLink?.setAttribute('aria-haspopup', 'dialog');
    cartLink?.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink?.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.querySelector('.cart-drawer__inner').setAttribute('aria-hidden', 'false');

    this.addEventListener('transitionend', () => {
      this.focusOnCartDrawer();
    }, { once: true });

    document.body.classList.add('overflow-hidden');

    // History integration: botão voltar do mobile fecha o drawer em vez de navegar fora da página
    if (!this._historyPushed) {
      this._historyPushed = true;
      try {
        history.pushState({ cartDrawerOpen: true }, '', location.href);
      } catch (e) {
        this._historyPushed = false;
      }
      this._popstateHandler = () => {
        if (this.classList.contains('is-visible')) {
          this._skipHistoryBack = true;
          this.close();
        }
      };
      window.addEventListener('popstate', this._popstateHandler);
    }
  }

  close() {
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);

    const isHeaderMenuOpen = header.classList.contains('menu-open');

    if (isHeaderMenuOpen) {
      return;
    }

    document.body.classList.remove('overflow-hidden');

    // History integration: remove a entrada fake do history se o fechamento não veio do botão voltar
    if (this._historyPushed) {
      this._historyPushed = false;
      if (this._popstateHandler) {
        window.removeEventListener('popstate', this._popstateHandler);
        this._popstateHandler = null;
      }
      if (!this._skipHistoryBack) {
        try {
          history.back();
        } catch (e) {}
      }
      this._skipHistoryBack = false;
    }

    // if we are on the cart page, resubmit form
    if (window.location.pathname === '/cart') {
      const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
    });
    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  focusOnCartDrawer() {
    const cartDrawer = this.querySelector('.cart-drawer');
    if (cartDrawer) {
      // cartDrawer.setAttribute('tabindex', '0');
      cartDrawer.focus();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/*
 * Opção "embalagem de presente": liga e desliga uma frase na observação do
 * pedido (cart.note), sem mexer no resto do que o cliente escreveu. Salva na
 * hora por /cart/update; o campo escondido do resumo ainda leva a observação
 * junto com o "Finalizar compra", caso o salvamento esteja a caminho.
 *
 * O #CartDrawer-Body é re-renderizado a cada mudança no carrinho, criando um
 * elemento novo a cada vez, então a fila de salvamentos é compartilhada: os
 * pedidos saem na ordem dos cliques e o último vence.
 */
let giftWrapQueue = Promise.resolve();
let giftWrapPending = 0;
let giftWrapSavedNote = null;

class CartGiftWrap extends HTMLElement {
  connectedCallback() {
    if (this._initialised) return;
    this._initialised = true;

    this.toggle = this.querySelector('[data-gift-wrap-toggle]');
    this.noteInput = this.querySelector('[data-gift-wrap-note]');
    this.text = this.dataset.noteText || '';
    if (!this.toggle || !this.noteInput || !this.text) return;

    this.toggle.addEventListener('change', () => this.onChange());

    // Renderizado enquanto um salvamento ainda corria: o HTML pode ter saído
    // com a observação antiga. Acerta quando a fila terminar.
    if (giftWrapPending > 0) {
      giftWrapQueue.then(() => {
        if (giftWrapSavedNote !== null) this.reflect(giftWrapSavedNote);
      });
    }
  }

  onChange() {
    const previous = this.noteInput.value;
    const note = this.toggle.checked
      ? CartGiftWrap.withText(previous, this.text)
      : CartGiftWrap.withoutText(previous, this.text);

    this.noteInput.value = note;
    this.save(note, previous);
  }

  save(note, previous) {
    giftWrapPending += 1;

    giftWrapQueue = giftWrapQueue
      .then(() =>
        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          body: JSON.stringify({ note })
        })
      )
      .then(response => {
        if (!response.ok) throw new Error(`cart/update ${response.status}`);
        return response.json();
      })
      .then(cart => {
        giftWrapSavedNote = cart.note || '';
      })
      .catch(error => {
        console.error(error);
        // Não salvou: a caixa volta a mostrar o que o carrinho tem de verdade.
        if (this.isConnected) this.reflect(previous);
      })
      .finally(() => {
        giftWrapPending -= 1;
      });
  }

  reflect(note) {
    this.noteInput.value = note;
    this.toggle.checked = note.includes(this.text);
  }

  // A frase entra numa linha própria no fim da observação, uma vez só.
  static withText(note, text) {
    const current = (note || '').trim();
    if (current.includes(text)) return current;
    return current ? `${current}\n${text}` : text;
  }

  // Sai a frase e a linha em branco que sobraria no lugar dela.
  static withoutText(note, text) {
    return (note || '')
      .split(text)
      .join('')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }
}

if (!customElements.get('cart-gift-wrap')) {
  customElements.define('cart-gift-wrap', CartGiftWrap);
}
